import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home'
  },
  {
    displayName: 'Analytical',
    iconName: 'aperture',
    route: '/template/dashboards/dashboard1'
  },
  {
    displayName: 'eCommerce',
    iconName: 'shopping-cart',
    route: '/template/dashboards/dashboard2'
  },
  {
    displayName: 'Frontend pages',
    iconName: 'app-window',
    route: 'template/front-pages',
    children: [
      {
        displayName: 'Home Page',
        iconName: 'point',
        route: 'template/front-pages/homepage'
      },
      {
        displayName: 'About Us',
        iconName: 'point',
        route: 'template/front-pages/about'
      },
      {
        displayName: 'Blog',
        iconName: 'point',
        route: 'template/front-pages/blog'
      },
      {
        displayName: 'Blog Details',
        iconName: 'point',
        route: 'template/front-pages/blog-details'
      },
      {
        displayName: 'Portfolio',
        iconName: 'point',
        route: 'template/front-pages/portfolio'
      },
      {
        displayName: 'Pricing',
        iconName: 'point',
        route: 'template/front-pages/pricing'
      },
      {
        displayName: 'Contact',
        iconName: 'point',
        route: 'template/front-pages/contact'
      }
    ]
  },
  {
    navCap: 'Apps'
  },
  {
    displayName: 'Chat',
    iconName: 'message-2',
    route: 'template/apps/chat'
  },
  {
    displayName: 'Calendar',
    iconName: 'calendar-event',
    route: 'template/apps/calendar'
  },
  {
    displayName: 'Email',
    iconName: 'mail',
    route: 'template/apps/email/inbox'
  },
  {
    displayName: 'Kanban',
    iconName: 'checklist',
    route: 'template/apps/kanban'
  },
  {
    displayName: 'User Profile',
    iconName: 'user-circle',
    route: 'template/apps/profile-details',
    chip: true,
    chipClass: 'bg-error text-white',
    chipContent: 'New',
    children: [
      {
        displayName: 'Profile',
        iconName: 'point',
        route: 'template/apps/profile-details/profile'
      },
      {
        displayName: 'Followers',
        iconName: 'point',
        route: 'template/apps/profile-details/followers'
      },
      {
        displayName: 'Friends',
        iconName: 'point',
        route: 'template/apps/profile-details/friends'
      },
      {
        displayName: 'Gellary',
        iconName: 'point',
        route: 'template/apps/profile-details/gallery'
      }
    ]
  },
  {
    displayName: 'Ecommerce',
    iconName: 'basket',
    route: 'template/apps/product',
    chip: true,
    chipClass: 'border-error text-error',
    chipContent: 'New',
    children: [
      {
        displayName: 'Product List',
        iconName: 'point',
        route: 'template/apps/product/product-list'
      },
      {
        displayName: 'Add Product',
        iconName: 'point',
        route: 'template/apps/product/add-product'
      },
      {
        displayName: 'Edit Product',
        iconName: 'point',
        route: 'template/apps/product/edit-product'
      },
      {
        displayName: 'Shop',
        iconName: 'point',
        route: 'template/apps/product/shop'
      }
    ]
  },
  {
    displayName: 'Contacts',
    iconName: 'phone',
    route: 'template/apps/contacts'
  },
  {
    displayName: 'Courses',
    iconName: 'certificate',
    route: 'template/apps/courses'
  },
  {
    displayName: 'Employee',
    iconName: 'brand-ctemplar',
    route: 'template/apps/employee'
  },
  {
    displayName: 'Notes',
    iconName: 'note',
    route: 'template/apps/notes'
  },
  {
    displayName: 'Tickets',
    iconName: 'ticket',
    route: 'template/apps/tickets'
  },
  {
    displayName: 'Contact List',
    iconName: 'phone',
    route: 'template/apps/contact-list'
  },
  {
    displayName: 'Invoice',
    iconName: 'file-invoice',
    route: 'template/apps/invoice',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'template/apps/invoice/list'
      },
      {
        displayName: 'Detail',
        iconName: 'point',
        route: 'template/apps/invoice/viewInvoice/101'
      },
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'template/apps/invoice/addInvoice'
      },
      {
        displayName: 'Edit',
        iconName: 'point',
        route: 'template/apps/invoice/editinvoice/101'
      }
    ]
  },
  {
    displayName: 'ToDo',
    iconName: 'edit',
    route: 'template/apps/todo'
  },
  {
    displayName: 'Blog',
    iconName: 'chart-donut-3',
    route: 'template/apps/blog',
    children: [
      {
        displayName: 'Post',
        iconName: 'point',
        route: 'template/apps/blog/post'
      },
      {
        displayName: 'Detail',
        iconName: 'point',
        route: 'template/apps/blog/detail/Early Black Friday Amazon deals: cheap TVs, headphones, laptops'
      }
    ]
  },
  {
    navCap: 'Pages'
  },
  {
    displayName: 'Roll Base Access',
    iconName: 'lock-access',
    route: 'template/apps/permission'
  },
  {
    displayName: 'Treeview',
    iconName: 'git-merge',
    route: 'template/theme-pages/treeview'
  },
  {
    displayName: 'Pricing',
    iconName: 'currency-dollar',
    route: 'template/theme-pages/pricing'
  },
  {
    displayName: 'Account Setting',
    iconName: 'user-circle',
    route: 'template/theme-pages/account-setting'
  },
  {
    displayName: 'FAQ',
    iconName: 'help',
    route: 'template/theme-pages/faq'
  },
  {
    displayName: 'Landingpage',
    iconName: 'app-window',
    route: 'template/landingpage'
  },
  {
    displayName: 'Widgets',
    iconName: 'layout',
    route: 'template/widgets',
    children: [
      {
        displayName: 'Cards',
        iconName: 'point',
        route: 'template/widgets/cards'
      },
      {
        displayName: 'Banners',
        iconName: 'point',
        route: 'template/widgets/banners'
      },
      {
        displayName: 'Charts',
        iconName: 'point',
        route: 'template/widgets/charts'
      }
    ]
  },
  {
    navCap: 'Forms'
  },
  {
    displayName: 'Form elements',
    iconName: 'apps',
    route: 'template/forms/forms-elements',
    children: [
      {
        displayName: 'Autocomplete',
        iconName: 'point',
        route: 'template/forms/forms-elements/autocomplete'
      },
      {
        displayName: 'Button',
        iconName: 'point',
        route: 'template/forms/forms-elements/button'
      },
      {
        displayName: 'Checkbox',
        iconName: 'point',
        route: 'template/forms/forms-elements/checkbox'
      },
      {
        displayName: 'Radio',
        iconName: 'point',
        route: 'template/forms/forms-elements/radio'
      },
      {
        displayName: 'Datepicker',
        iconName: 'point',
        route: 'template/forms/forms-elements/datepicker'
      }
    ]
  },
  {
    displayName: 'Form Layouts',
    iconName: 'file-description',
    route: '/template/forms/form-layouts'
  },
  {
    displayName: 'Form Horizontal',
    iconName: 'box-align-bottom',
    route: '/template/forms/form-horizontal'
  },
  {
    displayName: 'Form Vertical',
    iconName: 'box-align-left',
    route: '/template/forms/form-vertical'
  },
  {
    displayName: 'Form Wizard',
    iconName: 'files',
    route: '/template/forms/form-wizard'
  },
  {
    displayName: 'Toastr',
    iconName: 'notification',
    route: '/template/forms/form-toastr'
  },
  {
    displayName: 'Editor',
    iconName: 'edit',
    route: '/template/forms/form-editor',
    chip: true,
    chipClass: 'bg-error text-white',
    chipContent: 'New'
  },
  {
    navCap: 'Tables'
  },
  {
    displayName: 'Tables',
    iconName: 'layout',
    route: 'template/tables',
    children: [
      {
        displayName: 'Basic Table',
        iconName: 'point',
        route: 'template/tables/basic-table'
      },
      {
        displayName: 'Dynamic Table',
        iconName: 'point',
        route: 'template/tables/dynamic-table'
      },
      {
        displayName: 'Expand Table',
        iconName: 'point',
        route: 'template/tables/expand-table'
      },
      {
        displayName: 'Filterable Table',
        iconName: 'point',
        route: 'template/tables/filterable-table'
      },
      {
        displayName: 'Footer Row Table',
        iconName: 'point',
        route: 'template/tables/footer-row-table'
      },
      {
        displayName: 'HTTP Table',
        iconName: 'point',
        route: 'template/tables/http-table'
      },
      {
        displayName: 'Mix Table',
        iconName: 'point',
        route: 'template/tables/mix-table'
      },
      {
        displayName: 'Multi Header Footer',
        iconName: 'point',
        route: 'template/tables/multi-header-footer-table'
      },
      {
        displayName: 'Pagination Table',
        iconName: 'point',
        route: 'template/tables/pagination-table'
      },
      {
        displayName: 'Row Context Table',
        iconName: 'point',
        route: 'template/tables/row-context-table'
      },
      {
        displayName: 'Selection Table',
        iconName: 'point',
        route: 'template/tables/selection-table'
      },
      {
        displayName: 'Sortable Table',
        iconName: 'point',
        route: 'template/tables/sortable-table'
      },
      {
        displayName: 'Sticky Column',
        iconName: 'point',
        route: 'template/tables/sticky-column-table'
      },
      {
        displayName: 'Sticky Header Footer',
        iconName: 'point',
        route: 'template/tables/sticky-header-footer-table'
      }
    ]
  },
  {
    displayName: 'Data table',
    iconName: 'border-outer',
    route: '/template/datatable/kichen-sink'
  },
  {
    navCap: 'Chart'
  },
  {
    displayName: 'Line',
    iconName: 'chart-line',
    route: '/template/charts/line'
  },
  {
    displayName: 'Gredient',
    iconName: 'chart-arcs',
    route: '/template/charts/gredient'
  },
  {
    displayName: 'Area',
    iconName: 'chart-area',
    route: '/template/charts/area'
  },
  {
    displayName: 'Candlestick',
    iconName: 'chart-candle',
    route: '/template/charts/candlestick'
  },
  {
    displayName: 'Column',
    iconName: 'chart-dots',
    route: '/template/charts/column'
  },
  {
    displayName: 'Doughnut & Pie',
    iconName: 'chart-donut-3',
    route: '/template/charts/doughnut-pie'
  },
  {
    displayName: 'Radialbar & Radar',
    iconName: 'chart-radar',
    route: '/template/charts/radial-radar'
  },
  {
    navCap: 'UI'
  },
  {
    displayName: 'Ui Components',
    iconName: 'box',
    route: 'template/ui-components',
    children: [
      {
        displayName: 'Badge',
        iconName: 'point',
        route: 'template/ui-components/badge'
      },
      {
        displayName: 'Expansion Panel',
        iconName: 'point',
        route: 'template/ui-components/expansion'
      },
      {
        displayName: 'Chips',
        iconName: 'point',
        route: 'template/ui-components/chips'
      },
      {
        displayName: 'Dialog',
        iconName: 'point',
        route: 'template/ui-components/dialog'
      },
      {
        displayName: 'Lists',
        iconName: 'point',
        route: 'template/ui-components/lists'
      },
      {
        displayName: 'Divider',
        iconName: 'point',
        route: 'template/ui-components/divider'
      },
      {
        displayName: 'Menu',
        iconName: 'point',
        route: 'template/ui-components/menu'
      },
      {
        displayName: 'Paginator',
        iconName: 'point',
        route: 'template/ui-components/paginator'
      },
      {
        displayName: 'Progress Bar',
        iconName: 'point',
        route: 'template/ui-components/progress'
      },
      {
        displayName: 'Progress Spinner',
        iconName: 'point',
        route: 'template/ui-components/progress-spinner'
      },
      {
        displayName: 'Ripples',
        iconName: 'point',
        route: 'template/ui-components/ripples'
      },
      {
        displayName: 'Slide Toggle',
        iconName: 'point',
        route: 'template/ui-components/slide-toggle'
      },
      {
        displayName: 'Slider',
        iconName: 'point',
        route: 'template/ui-components/slider'
      },
      {
        displayName: 'Snackbar',
        iconName: 'point',
        route: 'template/ui-components/snackbar'
      },
      {
        displayName: 'Tabs',
        iconName: 'point',
        route: 'template/ui-components/tabs'
      },
      {
        displayName: 'Toolbar',
        iconName: 'point',
        route: 'template/ui-components/toolbar'
      },
      {
        displayName: 'Tooltips',
        iconName: 'point',
        route: 'template/ui-components/tooltips'
      }
    ]
  },
  {
    navCap: 'Auth'
  },
  {
    displayName: 'Login',
    iconName: 'login',
    route: '/template/authentication',
    children: [
      {
        displayName: 'Login 1',
        iconName: 'point',
        route: '/template/authentication/login'
      },
      {
        displayName: 'Boxed Login',
        iconName: 'point',
        route: '/template/authentication/boxed-login'
      }
    ]
  },
  {
    displayName: 'Register',
    iconName: 'user-plus',
    route: '/template/authentication',
    children: [
      {
        displayName: 'Side Register',
        iconName: 'point',
        route: '/template/authentication/side-register'
      },
      {
        displayName: 'Boxed Register',
        iconName: 'point',
        route: '/template/authentication/boxed-register'
      }
    ]
  },
  {
    displayName: 'Forgot Password',
    iconName: 'rotate',
    route: '/template/authentication',
    children: [
      {
        displayName: 'Side Forgot Password',
        iconName: 'point',
        route: '/template/authentication/side-forgot-pwd'
      },
      {
        displayName: 'Boxed Forgot Password',
        iconName: 'point',
        route: '/template/authentication/boxed-forgot-pwd'
      }
    ]
  },
  {
    displayName: 'Two Steps',
    iconName: 'zoom-code',
    route: '/template/authentication',
    children: [
      {
        displayName: 'Side Two Steps',
        iconName: 'point',
        route: '/template/authentication/side-two-steps'
      },
      {
        displayName: 'Boxed Two Steps',
        iconName: 'point',
        route: '/template/authentication/boxed-two-steps'
      }
    ]
  },
  {
    displayName: 'Error',
    iconName: 'alert-circle',
    route: '/template/authentication/error'
  },
  {
    displayName: 'Maintenance',
    iconName: 'settings',
    route: '/template/authentication/maintenance'
  },
  {
    navCap: 'Other'
  },
  {
    displayName: 'Menu Level',
    iconName: 'box-multiple',
    route: '/template/menu-level',
    children: [
      {
        displayName: 'Menu 1',
        iconName: 'point',
        route: '/template/menu-1',
        children: [
          {
            displayName: 'Menu 1',
            iconName: 'point',
            route: '/template/menu-1'
          },

          {
            displayName: 'Menu 2',
            iconName: 'point',
            route: '/template/menu-2'
          }
        ]
      },

      {
        displayName: 'Menu 2',
        iconName: 'point',
        route: '/template/menu-2'
      }
    ]
  },
  {
    displayName: 'Disabled',
    iconName: 'ban',
    route: '/template/disabled',
    disabled: true
  },
  {
    displayName: 'Chip',
    iconName: 'mood-smile',
    route: '/',
    chip: true,
    chipClass: 'bg-primary text-white',
    chipContent: '9'
  },
  {
    displayName: 'Outlined',
    iconName: 'mood-smile',
    route: '/',
    chip: true,
    chipClass: 'bg-error text-white',
    chipContent: 'outlined'
  },
  {
    displayName: 'External Link',
    iconName: 'star',
    route: 'https://www.google.com/',
    external: true
  }
];
